import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function AlertDialog({name, main_message, message, ok, cancel, okFn , sx, enabled, variant="outlined", size="medium", onOpen=()=>{}}) {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
        onOpen();
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Button sx={sx} disabled={enabled} size={size} variant={variant} onClick={handleClickOpen}>
                {name}
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {main_message}
                </DialogTitle>
                { message ?
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {message}
                    </DialogContentText>
                </DialogContent>
                :''}
                <DialogActions>
                    <Button onClick={handleClose}>{cancel}</Button>
                    <Button onClick={()=>{ handleClose(); okFn();} } autoFocus>
                        {ok}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
